/**
 * Created by renlei on 19/03/17.
 */

// 获取url参数值
export function GetQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return decodeURI(r[2])
  return null
}
export function wechatAppId() {
  var wechatAppId = 'wx6054546f7e4e24b6'
  if (process.env.NODE_ENV === 'development-bendi') {
    wechatAppId = 'wxe6ecf541363d6271'
  }
  return wechatAppId
}
// hash模式下截取参数
// export function geturlkey(name) {
//   return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
// }
